// For author and viewer the url will be
// domain/cfStackKey/READ/PAGE/number
// READ and PAGE are optional. "number" is the PAGE number
// cfStackKey can have slashes e.g "ownerName/stackFolder/stackFile"
// parse the url to extract the cfStackKey

import { strings } from "./strings";

interface StackUrlInfo {
  ownerName: string;
  stackCfKey: string;
  validStackCfKey: boolean;
  stackFileName: string;
  read: boolean;
  page: number | false;
  queryParams?: {
    source?: string;
  };
}

// and should never contact the server.
export const utilityFileNames = [
  strings.common.unauthorized,
  strings.unset,
  strings.utility.alreadyAuth,
  strings.utility.badUrl,
  strings.utility.emailLinkExpired,
  strings.utility.loginError,
  strings.utility.networkError,
  strings.utility.noOwnerNameAssociatedWithEmail,
  strings.utility.postLogin,
  strings.utility.signedUp,
  strings.utility.signUpTime,
  strings.utility.unverifiedEmail,
] as const;

function isValidStackCfKey(stackCfKey: string | false): boolean {
  if (!stackCfKey) return false;
  const stackCfKeyArray = stackCfKey.split("/");
  if (stackCfKeyArray.length < 2) return false;
  if (stackCfKeyArray[0] === "") return false;
  if (stackCfKeyArray[1] === "") return false;

  if (utilityFileNames.find((name) => name === stackCfKeyArray[0])) return false;
  if (utilityFileNames.find((name) => name === stackCfKeyArray[1])) return false;

  return true;
}

// pass window.location.pathname as url or a StackCfKey..
export function getStackFromUrl(url: string): StackUrlInfo {
  // Split off query string if present

  let path = url;
  const queryParams: Record<string, string> = {};
  const queryIndex = url.indexOf("?");
  if (queryIndex !== -1) {
    path = url.substring(0, queryIndex);
    const queryString = url.substring(queryIndex + 1);
    for (const pair of queryString.split("&")) {
      const [key, value] = pair.split("=");
      if (key) queryParams[decodeURIComponent(key)] = value ? decodeURIComponent(value) : "";
    }
  }

  path.endsWith("/") ? path.slice(0, -1) : path; // remove any trailing slashes
  const locations = path.split("/");
  const ownerName = locations[1];
  const pageIndex = locations.indexOf(strings.reservedWords.page);
  const readIndex = locations.indexOf(strings.reservedWords.read);
  let lastIndex = 2; // default to 1 as it must have ownerName at least

  const read = readIndex > -1;
  const pageNumber = pageIndex > -1 ? Number.parseInt(locations[pageIndex + 1]) : false;

  if (pageNumber || read) {
    // order is important READ always comes before PAGE in the URL
    if (pageNumber) {
      lastIndex = pageIndex - 1;
    }

    if (read) {
      lastIndex = readIndex - 1;
    }
  } else {
    lastIndex = locations.length - 1;
  }

  const stackCfKeyArray: string[] = locations.slice(1, lastIndex + 1);

  const stackCfKey = stackCfKeyArray.length === 1 ? "" : stackCfKeyArray.join("/").replace(/\/+$/, ""); // remove any trailing slashes

  return {
    ownerName,
    page: pageNumber,
    read,
    stackCfKey,
    validStackCfKey: isValidStackCfKey(stackCfKey),
    stackFileName: locations[lastIndex],
    queryParams,
  };
}

export function getStackFromCfKey(stackCfKey: string) {
  const url = `/${stackCfKey}`;
  return getStackFromUrl(url);
}

export function IsEmbeddedURL(): boolean {
  const host = location.host
  return host.toLowerCase() === "author.quickpoint.me" || host === "localhost:3000";
}


